const REPORT_PATIENT_PRESENCE = 'REPORT_PATIENT_PRESENCE'
const PATIENT_PRESENCE_RECEIVED = 'PATIENT_PRESENCE_RECEIVED'
const PRUNE_PATIENT_PRESENCE = 'PRUNE_PATIENT_PRESENCE'

const reportPatientPresence = payload => ({ type: REPORT_PATIENT_PRESENCE, payload })
const patientPresenceReceived = payload => ({ type: PATIENT_PRESENCE_RECEIVED, payload })
const prunePatientPresence = payload => ({ type: PRUNE_PATIENT_PRESENCE, payload })

export default {
  REPORT_PATIENT_PRESENCE,
  PATIENT_PRESENCE_RECEIVED,
  PRUNE_PATIENT_PRESENCE,
  reportPatientPresence,
  patientPresenceReceived,
  prunePatientPresence
}
